<template>
  <div class="stockApp">
    <div class="stock">
      <Header></Header>
      <main>
        <div class="mainBottom">
          <div style="width:100%;overflow:hidden;">
            <div class="underHeader">
              <img src="../../assets/img/info.png" style="width:12px;display:inline-block;" />
              当前位置：
              <a href="/#/index">平台首页 ></a>
              专题数据 > 裁判文书
            </div>
            <div class="detailPage">
              <div class="xz">
             
              </div>
              <div class="title">{{this.$route.query.baseInfo_casename}}</div>
              <div class="source">
                <span>来源：中国裁判文书网</span>
                <span>发布日期：{{this.$route.query.baseInfo_publishDate}}</span>
              </div>
              <div class="table">
                <p class="titspan">案件信息</p>
                <table class="tables">
                  <tr>
                    <td class="column" width="15%">案号</td>
                    <td width="35%">{{this.$route.query.baseInfo_casenumber}}</td>
                    <td class="column" width="15%">裁判日期</td>
                    <td width="35%">{{this.$route.query.baseInfo_judgeDate}}</td>
                  </tr>
                  <tr>
                    <td class="column" width="15%">审理法院</td>
                    <td width="35%">{{this.$route.query.baseInfo_courtname}}</td>
                    <td class="column" width="15%">案件类型</td>
                    <td width="35%">{{this.$route.query.baseInfo_caseType}}</td>
                  </tr>
                  <tr>
                    <td class="column" width="15%">案由</td>
                    <td width="35%">{{this.$route.query.baseInfo_casereason}}</td>
                    <td class="column" width="15%">审理程序</td>
                    <td width="35%">{{this.$route.query.baseInfo_casetrialproduce}}</td>
                  </tr>
                </table>
                <p class="titspan">当事人信息</p>
                <table class="tables">
                  <tr>
                    <td class="column" width="15%">序号</td>
                    <td class="column" width="35%">当事人讼诉地位</td>
                    <td class="column" width="35%">当事人名称</td>
                  </tr>
                  <tr v-for="(v,i) in data" :key="i">
                    <td width="15%">{{i+1}}</td>
                    <td width="35%">{{v.caselitigantStatus}}</td>
                    <td width="35%">{{v.caselitigantName}}</td>
                  </tr>
                </table>
                <!-- <p class="titspan" >法律依据</p>
                <table class="tables" style="height:500px;overflow:auto;">
                  <tr>
                    <td class="column" width="15%">序号</td>
                    <td class="column" width="35%">法规</td>
                    <td class="column" width="35%">法条</td>
                  </tr>
                  <tr v-for="(v,i) in data2" :key="i">
                    <td width="15%">{{i+1}}</td>
                    <td width="35%">{{v.law}}</td>
                    <td width="35%">{{v.law_article}}</td>
                  </tr>
                </table> -->
              </div>
              <iframe
                v-if="data3!=null"
                class="iframe"
                :src="'/tentapi/wenshu/getWenshuContent?wenshuid='+this.$route.query.wenshu_id"
                frameborder="0"
              ></iframe>
            </div>
          </div>
        </div>
      </main>
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Header from "@/components/header";
import Footer from "@/components/footer";
import api from "@/../static/common/api/api.js";
import local from "@/assets/map/local.png";
export default {
  props: {},
  components: {
    Header,
    Footer
  },
  data() {
    return {
      data: [],
      data2: [],
      data3: []
    };
  },
  computed: {},
  methods: {
    getWenshuDetail() {
      var params = { id: this.$route.query.wenshu_id, type: "1" };
      api.getWenshuDetail(params).then(res => {
        this.data = res.data;
      });
    },
    getWenshuDetail2() {
      var params = { id: this.$route.query.wenshu_id, type: "2" };
      api.getWenshuDetail(params).then(res => {
        this.data2 = res.data;
      });
    },
    getWenshuDetail3() {
      var params = { id: this.$route.query.wenshu_id, type: "3" };
      api.getWenshuDetail(params).then(res => {
        this.data3 = res.data[0].fileKey;
        // console.log(this.data3[0].caseInfo_detail_whole);
      });
    }
  },
  created() {},
  mounted() {
    this.getWenshuDetail();
    this.getWenshuDetail2();
    this.getWenshuDetail3();
  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/tableScrollbar.less";

.stockApp {
  background: url("../../assets/img/bg.png") no-repeat top;
}
.stock {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  .mainBottom {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  // 面包屑样式
  .underHeader {
    display: inline-block;
    height: 55px;
    line-height: 55px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #dfecf7;
    overflow: hidden;
    a {
      color: #dfecf7;
    }
  }
  .detailPage {
    width: 100%;
    height: 100%;
    background: rgba(5, 43, 79, 0.3);
    border: 1px solid #08396a;
    border-radius: 0px 0px 2px 2px;
    margin: 0 auto;
    padding: 0 22px;
    box-sizing: border-box;
    .xz {
      font-size: 14px;
      font-weight: 400;
      color: #3c98f5;
      margin-top: 37px;
      text-align: right;
      img {
        width: 14px;
        height: 14px;
        vertical-align: middle;
      }
    }
    .title {
      width: 80%;
      font-size: 24px;
      font-weight: 400;
      color: #dfecf7;
      line-height: 42px;
      margin: 0 auto;
      text-align: center;
    }
    .source {
      width: 80%;
      font-size: 12px;
      font-weight: 400;
      color: #dfecf7;
      line-height: 42px;
      margin: 0 auto;
      text-align: right;
    }
    .table {
      width: 80%;
      margin: 0 auto;
      .titspan {
        margin-top: 40px;
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #dfecf7;
        line-height: 26px;
      }
      .tables {
        margin-top: 22px;
        width: 100%;
        td {
          height: 38px;

          border: 1px solid #08396a;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #dfecf7;
          text-indent: 6px;
        }
        .column {
          background: rgba(5, 43, 79, 0.8);
        }
      }
    }
  }
  .iframe {
    width: 80%;
    height: 800px;
    padding-top: 80px;
    // background: rgba(5, 43, 79, 0.3);
    margin: 0 auto;
    margin-top: 20px;
    padding: 0 22px;
    box-sizing: border-box;
  }
}
</style>
 


// WEBPACK FOOTER //
// src/view/judgement/detail.vue